import axios, { AxiosResponse } from 'axios';
import { PipelineRequest } from '../../types/pipeline';

export const GET_FSNS_ROUTE = '/product/fsnList';
export const REQUEST_ROUTE = '/request';
export const PRODUCT_ROUTE = '/product';
export const SUBMIT_REQUEST_ROUTE = '/request/updateStatusAndStage';
export const ALL_REQUESTS_ROUTE = '/request/roleBasedUserRequests';
export const SAVE_REQUEST_DRAFT = '/request/draft';
export const UPDATE_REQUEST_DRAFT = '/request/draft';
export const TRIGGER_PIPELINE_ROUTE = '/pipeline/trigger';
export const MODAL_UPLOAD_PIPELINE_ROUTE = '/pipeline/modelUpload';
export const REQUEST_STATUS_PIPELINE = '/pipeline/requestStatus/';
export const QC_REPORT_API = '/pipeline/sendQCResult/';

/**
 * Zulu
 */
export const getProductsforAllFSNs = (data?: Array<string>): Promise<AxiosResponse<any>> => {
    return axios.post(GET_FSNS_ROUTE, data);
};

/**
 * Zulu
 */
export const getProductsforRequest = (requestId: String): Promise<AxiosResponse<any>> => {
    return axios.get(`${GET_FSNS_ROUTE}/${requestId}`);
};

export const createRequest = (data?: any): Promise<AxiosResponse<any>> => {
    return axios.post(REQUEST_ROUTE, data);
};

export const submitRequest = (data?: any): Promise<AxiosResponse<any>> => {
    return axios.put(SUBMIT_REQUEST_ROUTE, data);
};

export const updateRequest = (id: string, data?: any): Promise<AxiosResponse<any>> => {
    return axios.put(`${REQUEST_ROUTE}/${id}`, data);
};

export const getAllRequests = (requestedRole: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${ALL_REQUESTS_ROUTE}/${requestedRole}`);
};

export const getRequest = (id: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${REQUEST_ROUTE}/${id}`);
};

export const getProductsPriorities = (id: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${REQUEST_ROUTE}/${id}/priorities`);
};

export const assignRequestToVendor = (data: any): Promise<AxiosResponse<any>> => {
    return axios.put(`${REQUEST_ROUTE}/assignToVendor`, data);
};

export const getAllProductStatuses = (id: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${REQUEST_ROUTE}/${id}/productstatus`);
};

export const approveProduct = (id: string): Promise<AxiosResponse<any>> => {
    return axios.post(`${PRODUCT_ROUTE}/${id}/approve`);
};
export const markRequestAsComplete = (id: string): Promise<AxiosResponse<any>> => {
    return axios.put(`${REQUEST_ROUTE}/${id}/approveAll`);
};

export const acceptRequestComplexities = (id: string, data: any): Promise<AxiosResponse<any>> => {
    return axios.post(`${REQUEST_ROUTE}/${id}/complexity`, data);
};

export const updateAssigneeStatus = (data: any): Promise<AxiosResponse<any>> => {
    return axios.put(`${REQUEST_ROUTE}/updateAssigneeStatus`, data);
};

export const getFsnData = (fsn: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${PRODUCT_ROUTE}/search-by-fsn/${fsn}`);
};

//TODO: need to merge this functions
export const triggerDownStreamPipelineRequest = (data): Promise<AxiosResponse<any>> => {
    return axios.post(TRIGGER_PIPELINE_ROUTE, data);
};

export const triggerGoLivePipeline = <T>(data: any): Promise<AxiosResponse<T>> => {
    return axios.post(TRIGGER_PIPELINE_ROUTE, data);
};

export const uploadModel = (files): Promise<AxiosResponse<any>> => {
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
    }

    formData.append('pipelinePath', 'upload');

    return axios.post(MODAL_UPLOAD_PIPELINE_ROUTE, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

export const getRequestStatus = <T>(params: PipelineRequest): Promise<AxiosResponse<T>> => {
    const request = `${REQUEST_STATUS_PIPELINE}${params.requestId}`;

    return axios.get(request);
};

export const sendQCReport = (requestId: string, data: any): Promise<AxiosResponse<any>> => {
    const request = `${QC_REPORT_API}${requestId}`;

    return axios.post(request, data);
};
